import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>Oracle Data Warehousing Development</h1>
          </div>
          <div className="imgSection">
            <img
              src={require("../../../images/courses/data warehouse.png")}
              alt=""
            />
          </div>
          <div className="heading">
            <h1>Oracle Data Warehousing Development</h1>
            <p>
              Oracle Data Warehousing Development is a Job Oriented Training
              Program. Candidates who join this Oracle Data Warehousing
              Development program will undergo a training on SQL, PL/SQL, UNIX &
              Shell Scripting. Oracle Data Warehousing Development Design and
              concepts, ETL (Extract, Transform & Load). Training will be
              provided as part of a hands-on industry strength ETL project. This
              project will walk you through the process of designing and
              building a real-life data mart for a Retail Sales Corporation.
            </p>

            <h3>Course Description –</h3>

            <h4>Unit 1 – Red Hat Essentials</h4>
            <ul>
              <li>Linux ideas and history. </li>
              <li>Linux usage basics </li>
              <li>Running commands and getting help </li>
              <li>Browsing the file system </li>
              <li> Users, groups and permissions</li>
              <li>Using the bash shell </li>
              <li>Standard i/o and pipes Network clients </li>
              <li>Advanced topics in users, groups and permissions </li>
              <li>Text processing tools </li>
              <li>Vim: an advanced text editor </li>
              <li>Basic system configuration tools </li>
              <li>Investigating the bash shell </li>
              <li> Finding and processing files</li>
              <li>Essential system administration tools </li>
              <li> The linux file system in depth</li>
            </ul>
            {/*  */}

            <h4>Unit 2 – Oracle SQL</h4>
            <ul>
              <li>Basic SQL Statement </li>
              <li>Restricting and Sorting Data</li>
              <li>Single Row Functions </li>
              <li>Displaying Data from Multiple Tables</li>
              <li> Aggregating Data by Using Group Functions</li>
              <li> Writing Sub queries</li>
              <li>Sqlplus, isqlplus </li>
              <li>Manipulating Data </li>
              <li>Managing Tables, Constraints </li>
              <li> Views</li>
              <li> Other Database Objects</li>
              <li> Controlling User Access</li>
              <li> Using Set Operators</li>
              <li> Hierarchical Retrieval</li>
              <li>Oracle Extensions to DML and DDL Statements </li>
            </ul>
            {/*  */}

            <h4>Unit 3 – PL/SQL Programming</h4>
            <ul>
              <li>Introduction. </li>
              <li>Declaring Variables </li>
              <li>Writing Executable Statements </li>
              <li>Interacting with the Oracle Server </li>
              <li>Writing Control Structures </li>
              <li>Working with Composite Data types</li>
              <li> Writing Explicit Cursors</li>
              <li> Advanced Explicit Cursor concepts</li>
              <li> Handling Exceptions</li>
              <li> Creating Functions</li>
              <li> Managing Subprograms</li>
              <li>Creating Packages </li>
              <li> More Package Concepts</li>
              <li> Using Oracle-Supplied Packages</li>
              <li>Creating Database Triggers </li>
              <li>More Trigger Concepts </li>
              <li>Managing Dependencies </li>
              <li> Manipulating Large Objects</li>
              <li>Creating Procedures </li>
            </ul>
            {/*  */}

            <h4>Unit 4 – UNIX Shell Scripting</h4>
            <ul>
              <li>Bash & bash scripts </li>
              <li>Writing & debugging </li>
              <li>Shell initialization files </li>
              <li>Shell variables, expansion, alias </li>
              <li> Grep, egrep, fgrep</li>
              <li> Sed, awk, sort, uniq</li>
              <li>Introduction to “if” </li>
              <li> Using case statement</li>
              <li> Interactive scripts</li>
              <li>Loop (for, while) </li>
              <li> I/O Redirection</li>
              <li> I/O Redirection</li>
              <li>Database connectivity</li>
              <li>Menu driven scripts </li>
              <li>Automated emails </li>
              <li>Cron scheduler </li>
            </ul>
            {/*  */}

            <h4>Unit 5 – Data Warehousing Project</h4>
            <ul>
              <li> Dealing with large amount of data (millions of rows)</li>
              <li> Database performance tuning</li>
              <li> Monitoring of daily & nightly jobs</li>
              <li> Data warehousing concepts</li>
              <li> Dimensional data modeling</li>
              <li> ETL – Extract Transform & Load</li>
              <li>Management </li>
            </ul>
            {/*  */}

            <h4>Unit 6 – International Certification Exams</h4>
            <ul>
              <li>Introduction to Oracle SQL (Exam code- IZ0-007) </li>
              <li> Oracle Program with PL/SQL (Exam code-IZ0-147)</li>
            </ul>
            {/*  */}
            <h4>Unit 7 -Placement Assistance</h4>
            <ul>
              <li>Preparation of the best resume </li>
              <li> Prepare for an Interview</li>
              <li>Most likely questions in interviews </li>
              <li>How to find a right job to match your skills </li>
              <li>How to get your resume short listed by HR </li>
              <li> Powerful resume searching techniques </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
